/* tslint:disable:variable-name */
import {IrwinAttributes} from './irwinAttributes';
import {Geometry} from './geometry';

export class IrwinIncident {
  constructor(irwinIncident: IrwinIncident) {
    this.attributes = new IrwinAttributes(irwinIncident.attributes);
    this.geometry = new Geometry(irwinIncident.geometry);
    this.attributes.IrwinID = this.scrubbedIrwinID()
  }
  attributes: IrwinAttributes;
  geometry: Geometry;
  scrubbedIrwinID() {
    let id = this.attributes.IrwinID.replace('\{', '').replace('\}', '');
    return id.toLowerCase()
  }
  latitude() {
    return this.geometry.latitude;
  }
  longitude() {
    return this.geometry.longitude;
  }
}



